import { createStore } from 'vuex'
import user from './modules/user'

// 创建空模块用于占位
const createEmptyModule = () => ({
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {},
  getters: {}
})

// 应用模块
const appModule = {
  namespaced: true,
  state: () => ({
    sidebar: { opened: true },
    device: 'desktop'
  }),
  mutations: {
    TOGGLE_SIDEBAR (state) {
      state.sidebar.opened = !state.sidebar.opened
    },
    SET_DEVICE (state, device) {
      state.device = device
    }
  },
  actions: {
    initApp ({ commit }) {
      const device = navigator.userAgent.includes('Mobile') ? 'mobile' : 'desktop'
      commit('SET_DEVICE', device)
    },
    toggleSidebar ({ commit }) {
      commit('TOGGLE_SIDEBAR')
    }
  },
  getters: {
    sidebar: state => state.sidebar,
    device: state => state.device
  }
}

export default createStore({
  modules: {
    user,
    app: appModule,
    department: createEmptyModule(),
    recruitment: createEmptyModule(),
    candidate: createEmptyModule(),
    interview: createEmptyModule()
  },
  strict: process.env.NODE_ENV !== 'production'
})
